// CONSTANTS are all caps.
const NS = 'PromoHeroCarousel';
const CLS = 'promoHeroCarousel';
const BLK = '.' + CLS + '-';
const SLIDE_TO_SHOW = 1;
const SPEED_TIME_TRANSITION = 1000;
const DELAY_TIME_TRANSITION = 3000;
const CLS_IS_INITED = 'is-initialized';
const CLS_DISABLED = 'disabled';

import * as utils from '../../../../global/js/utils';

export class PromoHeroCarousel {
	constructor(el) {
		this.el = el;
		this.$el = $(el);
		this.$slider = this.$el.find(`.${CLS}-slider`);
		this.$sliderWrap = this.$el.find(`.${CLS}-sliderWrap`);
		this.$btnNext = this.$el.find(`.${CLS}-btnNext`);
		this.$btnPrev = this.$el.find(`.${CLS}-btnPrev`);
		this.$slidePagination = this.$el.find(`.${CLS}-pagination`);
				
		this.delayTimeTransition = this.$el.data('delayTimeTransition');
		if (this.delayTimeTransition && !isNaN(this.delayTimeTransition)) {
			this.delayTimeTransition = parseInt(this.delayTimeTransition);
		} else {
			this.delayTimeTransition = DELAY_TIME_TRANSITION;
		}
				
		this.speedTimeTransition = this.$el.data('speedTimeTransition');
		if (this.speedTimeTransition && !isNaN(this.speedTimeTransition)) {
			this.speedTimeTransition = parseInt(this.speedTimeTransition);
		} else {
			this.speedTimeTransition = SPEED_TIME_TRANSITION;
		}

		this.initPromoSwiper();
	}

	initPromoSwiper() {
		const promoSwiper = new Swiper(this.$sliderWrap[0], {
			init: false,
			slidesPerView: SLIDE_TO_SHOW,
			mousewheel: false,
			lazy: true,	
			autoplay: {
			delay: this.delayTimeTransition,
			disableOnInteraction: false,
			},
			speed: this.speedTimeTransition, 
			loop: true,
			keyboard: {
			  enabled: true,
			},
			pagination: {
				el: this.$slidePagination[0],
				clickable: true,
			},
			navigation: {
				nextEl: this.$btnNext[0],
				prevEl: this.$btnPrev[0],
			}
		});

		promoSwiper.on('init', () => {
			this.$el.addClass(CLS_IS_INITED);
		});
		

		if (this.$slider.find(`.${CLS}-item`).length <= 1) {
			this.$sliderWrap.addClass( CLS_DISABLED );
			this.$slidePagination.addClass( CLS_DISABLED );
		} else {
			promoSwiper.init();
		}
	}
}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_04/_work/396/s/FrontEnd/src/views/blocks/promoHeroCarousel/js/promoHeroCarousel.js